"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotMapPin = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotMapPin = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M18.073 38.137c-2.855-.48-7.39-1.291-10.696-3.705-3.306-2.421-5.682-6.669-3.823-9.105C5.422 22.9 11.526 22.29 16.9 21.317c5.385-.981 10.032-2.328 13.28-1.24 3.239 1.09 5.06 4.607 6.027 7.637.977 3.03 1.083 5.566.134 7.686-.939 2.12-2.951 3.818-5.241 4.377-2.3.551-4.887-.029-6.927-.516-2.041-.487-3.236-.636-6.1-1.123Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("g", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.4 15.454C31.4 24.364 20.2 32 20.2 32S9 24.364 9 15.454c0-3.037 1.18-5.95 3.28-8.099A11.075 11.075 0 0 1 20.2 4c2.97 0 5.82 1.207 7.92 3.355a11.588 11.588 0 0 1 3.28 8.1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.2 19.273c2.062 0 3.733-1.71 3.733-3.819 0-2.108-1.671-3.818-3.733-3.818-2.062 0-3.733 1.71-3.733 3.819 0 2.108 1.671 3.818 3.733 3.818Z"
  })));
};
exports.SpotMapPin = SpotMapPin;
SpotMapPin.displayName = "SpotMapPin";